import React, { useEffect, useState } from 'react';
import { Form, Input, Button, App } from 'antd';
import { MailOutlined, LockOutlined } from '@ant-design/icons';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import authService from '../../Services/authService';
import { loginSucceeded, selectIsAuthenticated } from '../../store/authSlice';
import { homePathForRoles } from '../../Utils/roleNav';
import { toApiError } from '../../api/axiosClient';
import velorMark from '../../assets/velor-mark.jpg';

const Login = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const { message, modal } = App.useApp();

  const onForgot = () =>
    modal.info({
      title: 'Reset your password',
      content:
        'Password resets for administration accounts are handled by a Platform Administrator. Please contact your Platform Administrator to have your password reset.',
      okText: 'Got it',
    });
  const isAuthenticated = useSelector(selectIsAuthenticated);
  const [submitting, setSubmitting] = useState(false);

  const returnTo = params.get('returnTo');

  useEffect(() => {
    if (isAuthenticated) navigate(returnTo || '/', { replace: true });
  }, [isAuthenticated, navigate, returnTo]);

  const onFinish = async (values) => {
    setSubmitting(true);
    try {
      const data = await authService.login(values);
      dispatch(loginSucceeded(data));
      const target = returnTo || homePathForRoles(data.roles || []);
      navigate(target, { replace: true });
    } catch (error) {
      const { status, message: msg } = toApiError(error);
      message.error(
        status === 401 ? 'Invalid email or password.' : msg || 'Unable to sign in.'
      );
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="auth-viewport">
      <div className="auth-card">
        <div className="auth-mark">
          <span className="mark">
            <img src={velorMark} alt="VelorHR" />
          </span>
          <span className="word">VelorHR</span>
        </div>
        <div className="auth-brand">Welcome back</div>
        <div className="auth-sub">Sign in to your administration account</div>
        <Form layout="vertical" onFinish={onFinish} requiredMark={false} disabled={submitting}>
          <Form.Item
            name="email"
            label="Email"
            rules={[
              { required: true, message: 'Email is required' },
              { type: 'email', message: 'Enter a valid email' },
            ]}
          >
            <Input prefix={<MailOutlined />} placeholder="you@velorhr.com" autoComplete="username" />
          </Form.Item>
          <Form.Item
            name="password"
            label="Password"
            rules={[{ required: true, message: 'Password is required' }]}
          >
            <Input.Password
              prefix={<LockOutlined />}
              placeholder="Password"
              autoComplete="current-password"
            />
          </Form.Item>
          <div style={{ textAlign: 'right', marginTop: -6, marginBottom: 18 }}>
            <Button
              type="link"
              onClick={onForgot}
              style={{ padding: 0, height: 'auto', fontWeight: 600, fontSize: 13 }}
            >
              Forgot password?
            </Button>
          </div>
          <Button type="primary" htmlType="submit" block loading={submitting} size="large">
            Sign in
          </Button>
        </Form>
      </div>
    </div>
  );
};

export default Login;
